/**
 * @file Utilitaires d'affichage client (initiales, couleurs d'avatar, nom affiché).
 * @module packages.common.components.customer.utils.customerUtils
 */

/**
 * Génère les initiales d'un client à partir de son prénom et nom.
 *
 * @param {string} firstName - Prénom du client
 * @param {string} lastName - Nom du client
 * @return{string} Initiales en majuscules (ex: "JD" pour "John Doe")
 */
export const getInitials = (firstName, lastName) => {
  const first = firstName ? firstName.charAt(0).toUpperCase() : '';
  const last = lastName ? lastName.charAt(0).toUpperCase() : '';
  return `${first}${last}`;
};

/**
 * Génère une couleur d'avatar déterministe basée sur le nom du client.
 *
 * @param {string} name - Nom du client (prénom ou nom de famille)
 * @param {Object} theme - Thème Material-UI
 * @return{string} Code couleur du thème
 */
export const getClientColor = (name, theme) => {
  const colors = [
    theme.palette.primary.main,
    theme.palette.success.main,
    theme.palette.info.main,
    theme.palette.secondary.main,
    theme.palette.warning.main,
  ];

  if (!name) return colors[0];
  const charCode = name.charCodeAt(0);
  return colors[charCode % colors.length];
};

/**
 * Nom affiché d'un client : prénom et nom, ou le nom seul du format wellness, ou un libellé de repli.
 *
 * @param {Object} customer - Fiche client (`firstName`/`lastName`) ou client wellness (`name`)
 * @return {string} Nom affichable
 */
export const customerDisplayName = (customer) =>
  customer?.name || [customer?.firstName, customer?.lastName].filter(Boolean).join(' ') || 'Client sans nom';
